export type ImageRow = { count: number; aspect: number };

// How a set of photos is laid out (issue #415): a grid, not a stack. One
// photo is a single slightly wide frame; two sit side by side; three lead
// with a wide photo over a pair; four are a 2x2. Every row is a fixed
// aspect so the block never jumps as photos load. Beyond four is not
// possible (domain.MaxAttachments).
export function imageRows(count: number): ImageRow[] {
  switch (count) {
    case 0:
      return [];
    case 1:
      return [{ count: 1, aspect: 4 / 3 }];
    case 3:
      return [
        { count: 1, aspect: 2 },
        { count: 2, aspect: 1 },
      ];
    default:
      return Array.from({ length: Math.ceil(count / 2) }, (_, i) => ({
        count: Math.min(2, count - i * 2),
        aspect: 1,
      }));
  }
}

// "2 / 3": where a photo sits in its set, shown over the lightbox.
export function positionLabel(index: number, count: number): string {
  return `${index + 1} / ${count}`;
}

// The accessible name of one photo in the grid: says which one it is, so a
// screen reader user can tell the cells apart.
export function photoCellLabel(index: number, count: number): string {
  return count === 1 ? 'Photo, open full size' : `Photo ${index + 1} of ${count}, open full size`;
}
